// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__grdIK","footerContent":"Footer_footerContent__x6AI4","copyright":"Footer_copyright__wO1U5"};